// extracted by mini-css-extract-plugin
export default {"icon":"ArrowUpDown_icon__kp5vX","iconActive":"ArrowUpDown_iconActive__rcZtu"};